import { z } from 'zod';
/**
 * Tenant 通知聯絡人。
 *
 * 用途：通知工作流事件（submit / approve / reject / final_approved）給
 *      **沒有系統帳號的關係人**（老闆、生產組長、採購、副總...）。
 *
 * 設計選擇：all_events 粒度
 * - active 聯絡人會收到該 tenant 的所有工作流事件
 * - 不訂閱特定事件（簡化管理）
 * - 不提供 unsubscribe（純內部 B2B 業務信）
 *
 * 與 ad-hoc CC 配合：
 * - editor 提交版本時可額外傳 extra_cc_emails，與聯絡人列表合併
 */
// 聯絡人所屬單位：改為自由字串（不綁定特定公司名，由使用者填寫）
export const ContactOrgEnum = z.string().min(1).max(50);
export const ContactMetaSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email().toLowerCase().max(254),
    name: z.string().min(1).max(100),
    /** 自訂角色標籤（選填）：老闆 / 生產組長 / 採購 / 品管 / 副總 / 業務 / ...  */
    role_label: z.string().max(50).optional(),
    org: ContactOrgEnum,
    note: z.string().max(500).optional(),
    is_active: z.boolean().default(true),
    // 来源：从联系人分组导入的联系人带此标记，供分组编辑时同步匹配
    source_group_id: z.string().optional(),
    source_contact_id: z.string().optional(),
    created_at: z.number().int(),
    created_by_user_id: z.string().uuid(),
    updated_at: z.number().int(),
});
export const CreateContactSchema = z.object({
    email: z.string().trim().email().toLowerCase().max(254),
    name: z.string().trim().min(1).max(100),
    role_label: z.string().trim().max(50).optional(),
    org: ContactOrgEnum,
    note: z.string().max(500).optional(),
});
export const UpdateContactSchema = z
    .object({
    expected_updated_at: z.number().int(),
    name: z.string().trim().min(1).max(100).optional(),
    role_label: z.string().trim().max(50).optional(),
    org: ContactOrgEnum.optional(),
    note: z.string().max(500).optional(),
    is_active: z.boolean().optional(),
})
    .strict();
//# sourceMappingURL=contact.js.map